module.exports = __webpack_public_path__ + "img/16x9_border.2c5e67b3.jpg";